import { atom, useAtomValue } from "jotai";

/**
 * Detection mode standalone (PWA home screen) vs navigateur.
 *
 * `navigator.standalone` = iOS Safari (propriete propriétaire, la plus fiable).
 * `matchMedia display-mode` = standard W3C (Chrome Android, Edge, Firefox).
 * `__TAURI_INTERNALS__` = app desktop Tauri (pas de barre URL non plus).
 *
 * Frozen at boot comme useIsMobile — pas de reactivite.
 */

function detectStandaloneAtBoot(): boolean {
  if (typeof window === "undefined") return false;
  if ((navigator as any).standalone === true) return true;
  if (window.matchMedia("(display-mode: standalone)").matches) return true;
  if (window.matchMedia("(display-mode: fullscreen)").matches) return true;
  if ("__TAURI_INTERNALS__" in window) return true;
  return false;
}

const standaloneBootValue = detectStandaloneAtBoot();

export const isStandaloneAtom = atom<boolean>(standaloneBootValue);

export function useIsStandalone(): boolean {
  return useAtomValue(isStandaloneAtom);
}

export function isStandaloneSync(): boolean {
  return standaloneBootValue;
}
